
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class EmployeeQualificationDialog extends _Ext.DialogBase<EmployeeQualificationRow, any> {
        protected getFormKey() { return EmployeeQualificationForm.formKey; }
        protected getIdProperty() { return EmployeeQualificationRow.idProperty; }
        protected getLocalTextPrefix() { return EmployeeQualificationRow.localTextPrefix; }
        protected getNameProperty() { return EmployeeQualificationRow.nameProperty; }
        protected getService() { return EmployeeQualificationService.baseUrl; }
        protected getDeletePermission() { return EmployeeQualificationRow.deletePermission; }
        protected getInsertPermission() { return EmployeeQualificationRow.insertPermission; }
        protected getUpdatePermission() { return EmployeeQualificationRow.updatePermission; }

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        protected form = new EmployeeQualificationForm(this.idPrefix);

    }
}